import { useEffect, useState, useRef } from "react";

import "./PinoySummary.css";
const getSize = () => window.innerWidth <= 768 ? 'mobile' :  'desktop';
let lang = document.URL.toLowerCase().indexOf('/en/') > 0 ? 'en' : document.URL.toLowerCase().indexOf('/russ/') > 0 ? 'rus' : document.URL.toLowerCase().indexOf('/arb/') > 0 ? 'ar' : 'he';
const PinoySummary = function (props) {
    const errSrc = "/_layouts/15/images/Sites/Ralpam/icon_picture.png";
    const [size, setSize] = useState(getSize());
    const [items, setItems] = useState(null);
    useEffect(() => {
        setItems(props.items);
        const onResize = () => {
            setSize(getSize);
        };
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);
    const getImgURLWithRend = (img) => {
        var newIndex = size == 'mobile' ? 11 : 10;
        if (img != undefined) {

            if (img.indexOf("?RenditionID") >= 0) {
                var parmImdex = img.split('?RenditionID=')[1];//.substring(0, 1);
                //return img.replace('?RenditionID=' + parmImdex, '');
                return img.replace('?RenditionID=' + parmImdex, '?RenditionID=' + newIndex);
            }
            else {
                return img + '?RenditionID=' + newIndex;
            }
        }
        return "";
    }
    let headersText = [
        {
            en: {
                more: 'Find Out More',
               
            },
            he: {
                more: 'גלו עוד',
                
            },
            ar: {
                more: 'See More',
               
            },
            rus: {
                more: 'See More',
                
            }
        }

    ];
    return (<div className='pinuysummaryWrapper'>
        {items && items.map((item, index) => (
            <>
                <div className={`pinuysummary d-flex ${size=='mobile' ?' flex-column-reverse':
                    (index % 2 == 0 ? ' flex-row' : ' flex-row-reverse')} justify-content-between`}>                   
                    <div className='d-flex infocolumn align-items-center order-2 order-md-1'> 
                        <img
                            src={getImgURLWithRend(item.modLinksImg.ImageUrl)}
                            onError={(e) => e.target.src = errSrc}
                            className='pinuysummaryimg'
                            loading="lazy"
                        />
                    </div>
                    <div className='infocolumn  align-self-center mainbox d-flex flex-column align-items-center justify-content-center order-1 order-md-2'>
                        <div className=''>
                            <h2 className='d-flex justify-content-start'>{item.LinkTitle}</h2>
                            <p className='subtitle'>{item.modLinksText}</p>
                            <div className='captionLinkwrappwer'>
                                <a className='captionLink d-flex justify-content-start link1' href={item.modLinksLink.NavigateUrl} 
                                aria-label={`למידע נוסף על ${item.LinkTitle}`}>
                                    <div className='d-flex justify-content-between '>
                                    {headersText[0][lang]['more']}
                                        {document.dir === "rtl" ? <i className='pi pi-arrow-left' aria-hidden="true"></i>
                                                : <i className='pi pi-arrow-right' aria-hidden="true"></i>}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <h1>{item.LinkTitle}</h1>
            <h2>{index}</h2> */}
            </>
        ))}
    </div>);
}
export default PinoySummary;